import { Text, View } from "@react-pdf/renderer";

export default function QuotePdfFooter({ styles, selectedQuote, showTaxRate }) {
  /*
   * Totals are computed INLINE during render (no useEffect/useState).
   * @react-pdf renders headlessly in the pdf().toBlob() path (used by the
   * "View / Download" menu), where React effects do NOT run — so an
   * effect-based calculation left the state null and printed "$ NaN".
   * Each value is guarded so a product with an empty/null price or quantity
   * contributes 0 rather than poisoning the sum.
   */
  const subtotal = (selectedQuote?.quoteProducts || []).reduce((acc, item) => {
    const price = parseFloat(item?.price) || 0;
    const qty = parseFloat(item?.quantity) || 0;
    return acc + price * qty;
  }, 0);

  const applyTaxRate = showTaxRate !== false;
  const taxRate = applyTaxRate
    ? parseFloat(selectedQuote?.taxrate?.rate) || 0
    : 0;
  const taxAmount = subtotal * taxRate;
  const total = subtotal + taxAmount;

  return (
    <View style={{ flexDirection: "row", justifyContent: "flex-end" }}>
      <View
        style={{
          width: "30%",
          marginVertical: 30,
          flexDirection: "column",
          justifyContent: "flex-end",
          alignItems: "flex-end",
        }}
      >
        {/* Subtotal */}
        <View style={{ flexDirection: "row", gap: 3, alignItems: "center" }}>
          <View>
            <Text style={styles.headingSecond}>Subtotal</Text>
          </View>
          <View
            style={{
              border: 1.5,
              borderBottom: 0,
              marginLeft: 5,
              height: 15,
              width: "60%",
            }}
          >
            <Text style={[styles.headingSecond, { textAlign: "right" }]}>
              $ {subtotal.toFixed(2)}
            </Text>
          </View>
        </View>

        {/* Tax Rate */}
        {applyTaxRate && (
          <View
            style={{ flexDirection: "row", gap: 3, alignItems: "center" }}
          >
            <View>
              <Text style={[styles.headingSecond, { textAlign: "right" }]}>
                Tax Rate ( {selectedQuote?.taxrate?.rate || 0} )
              </Text>
            </View>
            <View
              style={{
                border: 1.5,
                borderBottom: 0,
                marginLeft: 5,
                height: 15,
                width: "60%",
              }}
            >
              <Text style={[styles.headingSecond, { textAlign: "right" }]}>
                $ {taxAmount.toFixed(2)}
              </Text>
            </View>
          </View>
        )}

        {/* Total */}
        <View style={{ flexDirection: "row", gap: 3, alignItems: "center" }}>
          <View>
            <Text style={[styles.headingSecond, { textAlign: "right" }]}>
              Total
            </Text>
          </View>
          <View
            style={{
              border: 1.5,
              marginLeft: 5,
              height: 18,
              width: "60%",
            }}
          >
            <Text style={[styles.headingSecond, { textAlign: "right" }]}>
              $ {total.toFixed(2)}
            </Text>
          </View>
        </View>
      </View>
    </View>
  );
}
